import { render, staticRenderFns } from "./TheModalHistorialClinico.vue?vue&type=template&id=da0003a8&"
import script from "./TheModalHistorialClinico.vue?vue&type=script&lang=js&"
export * from "./TheModalHistorialClinico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports